import React from 'react'
import {Route} from 'react-router-dom'
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import {googleServices} from "./data";

export const RouteWithCaptcha = ({component: Component, ...rest}) => {
    return (
        <Route
            {...rest}
            render={props => {
                return <GoogleReCaptchaProvider reCaptchaKey={googleServices.googleCaptchaV3} language="es">
                    <Component {...props} />
                </GoogleReCaptchaProvider>
            }}
        />
    )
}